export default __webpack_public_path__ + "static/media/checkers-2-rMAX.ca7b11ad.jpg";